export default "<div>\n  <div class=\"center\">\n    <label asp-for=\"TrackingNumber\">{{message}}</label>\n  </div>\n</div>"